export enum VehicleStatus {
  IN_USE = 'In Use',
  OUT_OF_SERVICE = 'Out of service',
}
